var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"news-info"},[_c('span',{staticClass:"source"},[_vm._v(_vm._s(_vm.data.source))]),_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm._f("timeAgo")(_vm.data.time)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }